import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Non-interactive backdrop for plan-gated UI; blocks pointer events on sibling content.
 */
export default function PlanUpgradeOverlay({
  title = 'Available on Growth',
  description = 'Upgrade your plan to unlock this feature.',
  billingTab = 'billing',
}) {
  const navigate = useNavigate();

  return (
    <div
      className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 rounded-lg bg-background/85 dark:bg-slate-950/90 backdrop-blur-[2px] border border-dashed border-amber-200/90 dark:border-amber-800/60 p-6 text-center"
      data-testid="plan-upgrade-overlay"
    >
      <Sparkles className="w-8 h-8 text-amber-500 shrink-0" aria-hidden />
      <div className="space-y-1 max-w-sm">
        <p className="text-sm font-semibold text-slate-900 dark:text-white">{title}</p>
        <p className="text-xs text-slate-600 dark:text-slate-400">{description}</p>
      </div>
      <Button
        type="button"
        size="sm"
        className="bg-amber-600 hover:bg-amber-700 text-white"
        onClick={() => navigate(`/dashboard/settings?tab=${billingTab}`)}
        data-testid="plan-upgrade-overlay-cta"
      >
        View plans
      </Button>
    </div>
  );
}
